export default __webpack_public_path__ + "static/media/logo-sm-light.0afc0d28.png";